import React from 'react';
import { Link } from 'react-router-dom';
import { Permission } from '../../../utils/helpers/permissions';
import PermissionGate from '../../../utils/hooks/PermissionGate';
import { PreScreenBankSearch } from './PreScreenSearch';

export const PreScreenBank = () => {
  return (
    <div className='space-y-3'>
      <nav
          className='flex w-full flex-col gap-2 border-b border-slate-200 py-2 text-sm lg:flex-row lg:items-center lg:justify-between'
          aria-label='Breadcrumb'
      >
        <ol className='inline-flex items-center gap-2'>
          <li>
            <Link to={'#'} className='text-primary-textGray hover:underline'>
              Questions
            </Link>
          </li>
          <li>
            <span className='text-gray-400'>/</span>
          </li>
          <li>
            <Link
                to={'#'}
                className='text-primary-main font-semibold hover:underline'
            >
              Pre Screen Question Bank
            </Link>
          </li>
        </ol>
        <div className='flex flex-wrap gap-2 text-xs font-semibold sm:text-sm'>
          <PermissionGate
              requiredPermissions={[Permission.QUESTIONS_VIEW]}
              matchAnyPermission={false}
          >
            <Link
                className='rounded-md px-2 py-1 text-primary-main hover:bg-emerald-50'
                to={'/question-bank'}
            >
              Question Bank
            </Link>
          </PermissionGate>
          <PermissionGate
              requiredPermissions={[Permission.JOB_VIEW]}
              matchAnyPermission={false}
          >
            <Link
                className='rounded-md px-2 py-1 text-primary-main hover:bg-emerald-50'
                to={'/content-manager'}
            >
              Content Manager
            </Link>
          </PermissionGate>
          <PermissionGate
              requiredPermissions={[Permission.JOB_CREATE]}
              matchAnyPermission={false}
          >
            <Link
                className='rounded-md px-2 py-1 text-primary-main hover:bg-emerald-50'
                to={'/upload-file'}
            >
              Auto Generate Questions
            </Link>
          </PermissionGate>
        </div>
      </nav>
      <PreScreenBankSearch />
    </div>
  );
};
